"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _superagent = _interopRequireDefault(require("superagent"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _OrsUtil = _interopRequireDefault(require("./OrsUtil"));

var _constants = _interopRequireDefault(require("./constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var orsUtil = new _OrsUtil["default"]();

var OrsMatrix = /*#__PURE__*/function () {
  function OrsMatrix(args) {
    _classCallCheck(this, OrsMatrix);

    this.meta = null;
    this.args = {};

    if (_constants["default"].propNames.apiKey in args) {
      this.args[_constants["default"].propNames.apiKey] = args[_constants["default"].propNames.apiKey];
    } else {
      // eslint-disable-next-line no-console
      console.log(_constants["default"].missingAPIKeyMsg);
      throw new Error(_constants["default"].missingAPIKeyMsg);
    }
  }

  _createClass(OrsMatrix, [{
    key: "calculate",
    value: function calculate(reqArgs) {
      // Get custom header and remove from args
      this.customHeaders = [];

      if (reqArgs.customHeaders) {
        this.customHeaders = reqArgs.customHeaders;
        delete reqArgs.customHeaders;
      }

      orsUtil.setRequestDefaults(this.args, reqArgs, true); // eslint-disable-next-line prettier/prettier

      if (!this.args[_constants["default"].propNames.service] && !reqArgs[_constants["default"].propNames.service]) {
        this.args[_constants["default"].propNames.service] = 'matrix';
      }

      orsUtil.copyProperties(reqArgs, this.args);
      var that = this;
      return new _bluebird["default"](function (resolve, reject) {
        var timeout = that.args[_constants["default"].propNames.timeout] || 10000; // eslint-disable-next-line prettier/prettier

        if (that.args[_constants["default"].propNames.apiVersion] === _constants["default"].defaultAPIVersion) {
          if (that.meta == null) {
            that.meta = orsUtil.prepareMeta(that.args);
          }

          that.httpArgs = orsUtil.prepareRequest(that.args);
          var url = orsUtil.prepareUrl(that.meta);
          var authorization = that.meta[_constants["default"].propNames.apiKey];

          var orsRequest = _superagent["default"].post(url).send(that.httpArgs).set('Authorization', authorization).timeout(timeout);

          for (var key in that.customHeaders) {
            orsRequest.set(key, that.customHeaders[key]);
          }

          orsRequest.end(function (err, res) {
            if (err || !res.ok) {
              // eslint-disable-next-line no-console
              console.error(err);
              reject(err);
            } else if (res) {
              resolve(res.body || res.text);
            }
          });
        } else {
          // eslint-disable-next-line no-console
          console.error(_constants["default"].useAPIV2Msg);
        }
      });
    }
  }]);

  return OrsMatrix;
}();

var _default = OrsMatrix;
exports["default"] = _default;